<template>
  <v-container class="pa-0">
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(save)">
        <!-- Header Section -->
        <v-sheet color="primary" class="pa-6 d-flex align-center">
          <v-avatar size="40" color="white opacity-20" class="mr-4">
            <v-icon color="white" small>fas fa-project-diagram</v-icon>
          </v-avatar>
          <div>
            <div class="text-h5 white--text font-weight-black">{{ id > -1 ? 'Actualizar Etapa' : 'Nueva Etapa de Prefe-Prensa' }}</div>
            <div class="caption white--text opacity-70">Configure el nombre y orden del flujo</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="$emit('close')"><v-icon small>fas fa-times</v-icon></v-btn>
        </v-sheet>

        <v-card-text class="pa-8">
          <v-row>
            <v-col cols="12" md="8">
              <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                <v-text-field
                  label="Nombre de la Etapa"
                  v-model="item.name"
                  outlined dense hide-details="auto"
                  class="modern-input mb-4"
                  :error-messages="errors"
                  :loading="loading"
                  placeholder="Ej: Aprobación Cliente, Diseño Finalizado..."
                />
              </ValidationProvider>

              <ValidationProvider name="Orden" rules="required" v-slot="{ errors }">
                <v-text-field
                  label="Orden de Ejecución"
                  type="number"
                  v-model="item.sort"
                  outlined dense hide-details="auto"
                  class="modern-input mb-6"
                  :error-messages="errors"
                  :loading="loading"
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12" md="4" class="d-flex flex-column align-center justify-center">
              <div class="caption grey--text font-weight-black text-uppercase mb-2">Color Distintivo</div>
              <div class="color-preview-container pa-1 rounded-pill shadow-sm mb-2" :style="`background-color: ${item.color || '#primary'}`">
                <v-avatar size="60" :color="item.color || 'primary'" class="border-white" />
              </div>
            </v-col>

            <v-col cols="12">
              <div class="caption grey--text font-weight-black text-uppercase mb-3 px-2">Selector de Color</div>
              <v-sheet outlined class="rounded-xl overflow-hidden shadow-xs">
                <v-color-picker
                  v-model="item.color"
                  hide-inputs
                  width="100%"
                  flat
                  canvas-height="120"
                />
              </v-sheet>
            </v-col>

            <v-col cols="12">
              <v-switch
                v-model="item.enabled"
                inset
                hide-details
                color="primary"
                :label="item.enabled ? 'Etapa activa' : 'Etapa desactivada'"
                class="mt-2"
              />
              <div class="caption grey--text px-2">
                Las etapas desactivadas no aparecen al asignar productos, pero conservan su histórico.
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-6 bg-grey-light">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" class="font-weight-bold px-6" @click="$emit('close')">Cancelar</v-btn>
          <v-btn type="submit" color="primary" depressed class="font-weight-bold px-8 shadow-sm" :loading="loading">
            <v-icon small class="mr-2">fas fa-save</v-icon> Guardar Etapa
          </v-btn>
        </v-card-actions>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { getStage, createStage, updateStage } from '@/api/production'
import notifications from '@/utils/notifications'

export default {
  name: 'StageCreateUpdate',
  props: ['id'],
  data() {
    return {
      item: { name: '', sort: 1, color: '#1976D2', enabled: true },
      loading: false,
    }
  },
  methods: {
    async save() {
      this.loading = true
      try {
        const payload = {
          name: this.item.name,
          sort: this.item.sort,
          color: this.item.color,
          enabled: this.item.enabled
        }
        if (this.id > -1) {
          await updateStage(this.id, payload)
          notifications.showSuccess('Etapa actualizada correctamente')
        } else {
          await createStage(payload)
          notifications.showSuccess('Etapa creada correctamente')
        }
        this.$emit('updated')
        this.$emit('close')
        this.$store.dispatch('getStages')
      } catch (err) {
        notifications.showError('Error al guardar etapa: ' + err)
      } finally {
        this.loading = false
      }
    },
    async get() {
      if (this.id > -1) {
        this.loading = true
        try {
          const res = await getStage(this.id)
          this.item = res
        } catch (err) {
          notifications.showError('Error al cargar etapa: ' + err)
        } finally {
          this.loading = false
        }
      } else {
        this.item = { id: -1, name: '', sort: 1, color: '#1976D2', enabled: true }
      }
    }
  },
  watch: {
    id: { handler: 'get', immediate: true }
  }
}
</script>

<style scoped>
.bg-grey-light { background-color: #f8f9fa; }
.opacity-20 { background-color: rgba(255,255,255,0.2) !important; }
.opacity-70 { opacity: 0.7; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important; }
.shadow-xs { box-shadow: 0 1px 4px rgba(0,0,0,0.05) !important; }
.color-preview-container { border: 4px solid #fff; }
.border-white { border: 2px solid #fff !important; }
</style>